<template>
  <section data-test="filter-sme-section">
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="osm-select">สสว.</label>
      <v-select
        data-test="osm-select"
        id="osm-select"
        v-model="modelValueComputed"
        :options="osmOptions"
        :clearable="true"
        placeholder="กรุณาเลือกสสว."
        :appendToBody="true"
        label="text"
      >
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            ไม่พบข้อมูล
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
    </div>
  </section>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  modelValue: Object,
});
const emits = defineEmits(["update:modelValue"]);

const store = useStore();


const osmOptions = reactive(
  [
    {value: "1", text: "สสว.1"},
    {value: "2", text: "สสว.2"},
    {value: "3", text: "สสว.3"},
    {value: "4", text: "สสว.4"},
    {value: "5", text: "สสว.5"},
    {value: "6", text: "สสว.6"},
    {value: "7", text: "สสว.7"},
    {value: "8", text: "สสว.8"},
    {value: "9", text: "สสว.9"},
    {value: "10", text: "สสว.10"},
    {value: "11", text: "สสว.11"}
  ]
);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});

</script>
